import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IProductTypeModel, IProductTypes } from "../../models/product/product.model";
import { EnvironmentService } from "../environment.service";

@Injectable({
    providedIn: 'root'
})
export class ProductTypeService {
    fullPath: string;
    constructor(private readonly httpClient: HttpClient, public envService: EnvironmentService) {
        this.fullPath = `${envService.settings.apiUrl}/productTypes`;
    }

    public save(model: IProductTypeModel): Observable<IProductTypeModel> {
        return this.httpClient.post<IProductTypeModel>(this.fullPath, model);
    }

    public update(model: IProductTypeModel): Observable<IProductTypeModel> {
        return this.httpClient.put<IProductTypeModel>(this.fullPath, model);
    }

    
    public getAll(): Observable<IProductTypes> {
        return this.httpClient.get<IProductTypes>(`${this.envService.settings.apiUrl}/productTypes`);
    }
}